<template>
    <div class="room-sleep-timer" @keydown.esc="open = false">
        <button type="button" class="room-sleep-trigger" :class="{'is-active': !!timer}"
                :aria-expanded="open" @click="open = !open">
            <svg class="room-sleep-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                <circle cx="12" cy="12" r="8"></circle>
                <path d="M12 8v4l3 2"></path>
            </svg>
            <span class="room-sleep-title">定时</span>
            <span v-if="timer" class="room-sleep-status" :class="{'is-expired': isExpired}">{{ statusText }}</span>
        </button>
        <div v-if="open" class="room-sleep-panel">
        <div class="room-sleep-options" role="group" aria-label="选择个人定时">
            <button v-for="minutes in minuteOptions" :key="minutes" type="button"
                    :class="{'is-selected': isSelected(minutes)}" :aria-pressed="isSelected(minutes)"
                    @click="select(minutes)">{{ minutes }} 分钟</button>
            <button type="button" :class="{'is-selected': isSelected('after-song')}"
                    :aria-pressed="isSelected('after-song')" :disabled="!canAfterSong"
                    :title="canAfterSong ? '当前歌曲结束或房间换曲后，仅暂停你的播放器' : '当前没有可播放的歌曲'"
                    @click="select('after-song')">播完本首</button>
            <button v-if="timer" type="button" class="room-sleep-cancel" @click="$emit('cancel'); open = false">取消定时</button>
        </div>
        <div class="room-sleep-note">仅暂停你的播放器，其他人继续听歌。</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SleepTimer',
    props: {
        timer: {type: Object, default: null},
        remaining: {type: Number, default: null},
        canAfterSong: {type: Boolean, default: false}
    },
    data: () => ({minuteOptions: [15, 30, 60], open: false}),
    computed: {
        isExpired() { return !!this.timer && this.timer.status === 'expired'; },
        statusText() {
            if (!this.timer) return '未启用';
            if (this.isExpired) return '定时已到，已暂停';
            if (this.timer.mode === 'after-song') return '本首结束后暂停';
            const seconds = Math.max(0, Math.ceil((this.remaining || 0) / 1000));
            return '剩余 ' + String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
        }
    },
    methods: {
        select(value) { this.$emit('select', value); this.open = false; },
        isSelected(value) {
            if (!this.timer || this.isExpired) return false;
            return value === 'after-song' ? this.timer.mode === 'after-song'
                : this.timer.mode === 'deadline' && this.timer.minutes === value;
        }
    }
};
</script>

<style scoped>
.room-sleep-timer { position: relative; flex: 0 1 auto; width: auto; max-width: 100%; color: var(--room-text); }
.room-sleep-trigger { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 6px; min-height: 36px; max-width: 100%; padding: 6px 12px; border: 1px solid var(--room-border); border-radius: 18px; background: transparent; color: var(--room-text-secondary); cursor: pointer; }
.room-sleep-trigger:hover { background: var(--room-hover); }
.room-sleep-trigger:focus-visible { outline: 2px solid var(--room-accent-border); outline-offset: 2px; }
.room-sleep-icon { flex-shrink: 0; }
.room-sleep-trigger.is-active { border-color: var(--room-accent-border); }
.room-sleep-panel { position: absolute; right: 0; bottom: calc(100% + 10px); z-index: 10; box-sizing: border-box; width: 288px; max-width: calc(100vw - 96px); padding: 12px; border: 1px solid var(--room-border); border-radius: 14px; background: var(--room-panel); box-shadow: 0 8px 28px rgba(var(--room-shadow-rgb), .16); text-align: left; }
.room-sleep-title { font-size: 13px; font-weight: 600; }
.room-sleep-status { font-size: 12px; color: var(--room-text-secondary); font-variant-numeric: tabular-nums; }
.room-sleep-status.is-expired { color: var(--room-accent); }
.room-sleep-options { display: flex; flex-wrap: wrap; gap: 6px; }
.room-sleep-options button { flex: 1 1 calc(50% - 3px); min-height: 34px; padding: 4px 10px; border: 1px solid var(--room-border); border-radius: 8px; background: var(--room-input); color: var(--room-text-secondary); font: inherit; font-size: 12px; cursor: pointer; }
.room-sleep-options button:hover:not(:disabled) { background: var(--room-hover); }
.room-sleep-options button.is-selected { border-color: var(--room-accent); background: var(--room-accent); color: var(--room-on-accent); }
.room-sleep-options button:disabled { opacity: .5; cursor: not-allowed; }
.room-sleep-options button:focus-visible { outline: 2px solid var(--room-accent-border); outline-offset: 2px; }
.room-sleep-options button.room-sleep-cancel { border-color: transparent; background: transparent; }
.room-sleep-note { margin-top: 7px; color: var(--room-text-muted); font-size: 11px; line-height: 1.5; }
@media (max-width: 766px) {
    .room-sleep-panel { padding: 8px 10px; }
    .room-sleep-options button { flex: 1 0 auto; min-height: 34px; padding: 4px 8px; }
}
</style>
